import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import Subjects from "Administrator/routes/DPAcademicSetup/routes/DPSubjects";
import SubjectsSetupV2 from "Platform/routes/AcademicPortal/routes/SubjectsSetupV2";
import EESubjects from "Administrator/routes/DPAcademicSetup/routes/EESubjects";

export default store => ({
  path: "dp-subjects",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [Subjects(store), SubjectsSetupV2(store), EESubjects(store)],
});
